import styled from 'styled-components';
import { Button, Heading, Text, tombac } from 'tombac';
import { CancelIcon } from 'tombac-icons';
import CONFIG from 'app/modules/core/config';
import { ProductLogo } from 'app/modules/products/components/ProductLogo';
import { useFormatUserDate } from "../core/useFormatUserDate";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Modal = styled.div.withConfig({
  displayName: "TryForFreeModal__Modal"
})([""]);
const ModalOverlay = styled.div.withConfig({
  displayName: "TryForFreeModal__ModalOverlay"
})(["position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.4);display:none;@media (min-width:680px){display:block;}"]);
const ModalBox = styled.div.withConfig({
  displayName: "TryForFreeModal__ModalBox"
})(["position:fixed;top:0;left:0;background:white;width:100%;height:100%;z-index:1000;@media (min-width:680px){position:fixed;width:570px;height:auto;top:50%;left:50%;transform:translate(-50%,-50%);}"]);
const ModalBoxTop = styled.div.withConfig({
  displayName: "TryForFreeModal__ModalBoxTop"
})(["display:flex;align-items:center;border-bottom:1px solid ", ";padding:", ";@media (min-width:680px){padding:", ";}"], tombac.color('neutral', 400), tombac.space(2), tombac.space(4, 4, 4, 6));
const ModalLogo = styled.div.withConfig({
  displayName: "TryForFreeModal__ModalLogo"
})(["margin-right:", ";height:32px;svg{width:32px;height:32px;}"], tombac.space(2));
const ModalTitle = styled.div.withConfig({
  displayName: "TryForFreeModal__ModalTitle"
})(["font-family:var(--alt-font-family);font-size:16px;font-weight:bold;line-height:1.5;color:", ";"], tombac.color('neutral', 900));
const ModalCloseButton = styled.button.withConfig({
  displayName: "TryForFreeModal__ModalCloseButton"
})(["display:block;margin-left:auto;border:none;background:transparent;color:", ";cursor:pointer;&:hover{color:", ";}"], tombac.color('neutral', 500), tombac.color('neutral', 900));
const ModalBoxContent = styled.div.withConfig({
  displayName: "TryForFreeModal__ModalBoxContent"
})(["padding:", " ", ";"], tombac.space(4), tombac.space(6));
const ModalBoxText = styled(Text).withConfig({
  displayName: "TryForFreeModal__ModalBoxText"
})(["margin-top:", ";"], tombac.space(4));
const StartEvaluationButton = styled(Button).withConfig({
  displayName: "TryForFreeModal__StartEvaluationButton"
})(["margin-top:", ";"], tombac.space(4));
function TryForFreeModal({
  product,
  isAccountBeingCreated,
  onConfirm,
  onClose
}) {
  const EVALUATION_LENGTH_IN_DAYS = CONFIG.EVALUATION[product.id].evaluationLengthInDays;
  const evaluationEnd = new Date();
  evaluationEnd.setDate(evaluationEnd.getDate() + EVALUATION_LENGTH_IN_DAYS);
  const formatDate = useFormatUserDate();
  return /*#__PURE__*/_jsxs(Modal, {
    "data-sentry-element": "Modal",
    "data-sentry-component": "TryForFreeModal",
    "data-sentry-source-file": "TryForFreeModal.tsx",
    children: [/*#__PURE__*/_jsx(ModalOverlay, {
      onClick: onClose,
      "data-sentry-element": "ModalOverlay",
      "data-sentry-source-file": "TryForFreeModal.tsx",
      "data-sentry-element": "ModalOverlay"
    }), /*#__PURE__*/_jsxs(ModalBox, {
      "data-sentry-element": "ModalBox",
      "data-sentry-source-file": "TryForFreeModal.tsx",
      "data-sentry-element": "ModalBox",
      children: [/*#__PURE__*/_jsxs(ModalBoxTop, {
        "data-sentry-element": "ModalBoxTop",
        "data-sentry-source-file": "TryForFreeModal.tsx",
        "data-sentry-element": "ModalBoxTop",
        children: [/*#__PURE__*/_jsx(ModalLogo, {
          "data-sentry-element": "ModalLogo",
          "data-sentry-source-file": "TryForFreeModal.tsx",
          "data-sentry-element": "ModalLogo",
          children: /*#__PURE__*/_jsx(ProductLogo, {
            productId: product.id,
            "data-sentry-element": "ProductLogo",
            "data-sentry-source-file": "TryForFreeModal.tsx",
            "data-sentry-element": "ProductLogo"
          })
        }), /*#__PURE__*/_jsx(ModalTitle, {
          "data-sentry-element": "ModalTitle",
          "data-sentry-source-file": "TryForFreeModal.tsx",
          "data-sentry-element": "ModalTitle",
          children: product.displayName
        }), /*#__PURE__*/_jsx(ModalCloseButton, {
          onClick: onClose,
          "data-sentry-element": "ModalCloseButton",
          "data-sentry-source-file": "TryForFreeModal.tsx",
          "data-sentry-element": "ModalCloseButton",
          children: /*#__PURE__*/_jsx(CancelIcon, {
            "data-sentry-element": "CancelIcon",
            "data-sentry-source-file": "TryForFreeModal.tsx",
            "data-sentry-element": "CancelIcon"
          })
        })]
      }), /*#__PURE__*/_jsxs(ModalBoxContent, {
        "data-sentry-element": "ModalBoxContent",
        "data-sentry-source-file": "TryForFreeModal.tsx",
        "data-sentry-element": "ModalBoxContent",
        children: [/*#__PURE__*/_jsx(Heading, {
          level: 3,
          "data-sentry-element": "Heading",
          "data-sentry-source-file": "TryForFreeModal.tsx",
          "data-sentry-element": "Heading",
          children: "Want to start your free trial today?"
        }), /*#__PURE__*/_jsxs(ModalBoxText, {
          as: "div",
          "data-sentry-element": "ModalBoxText",
          "data-sentry-source-file": "TryForFreeModal.tsx",
          "data-sentry-element": "ModalBoxText",
          children: ["You are about to start your free", ' ', /*#__PURE__*/_jsxs("b", {
            children: [EVALUATION_LENGTH_IN_DAYS, " days"]
          }), " trial of", ' ', /*#__PURE__*/_jsx("b", {
            children: product.displayName
          }), ".", /*#__PURE__*/_jsx("br", {}), "Your trial expires on: ", /*#__PURE__*/_jsx("b", {
            children: formatDate(evaluationEnd)
          }), ".", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), "You will receive a confirmation email after completing the request form. The app is in ", /*#__PURE__*/_jsx("b", {
            children: "My products"
          }), "."]
        }), /*#__PURE__*/_jsx(StartEvaluationButton, {
          busy: isAccountBeingCreated,
          onClick: onConfirm,
          "data-sentry-element": "StartEvaluationButton",
          "data-sentry-source-file": "TryForFreeModal.tsx",
          "data-sentry-element": "StartEvaluationButton",
          children: "Start trial"
        })]
      })]
    })]
  });
}
export default TryForFreeModal;